import { formatDate } from '@btime/helpers'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  if (reply.question.type.name === 'select') {
    return reply.value?.name?.trim() || CONSTANTS.NA
  }
  return reply.value || CONSTANTS.NA
}

export const filterRepliesByQuestionName = (replies, name) => {
  return replies.filter(reply => reply.question.name === name)
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByQuestionNameOrId = (replies, questionName, questionId) => {
  let found = replies.find(reply => reply.question.name === questionName)
  if (found) return found

  found = replies.find(reply => reply.question.id === questionId)
  return found
}

export const findReplyByParentReference = (replies, reference) => {
  return replies.find(
    reply => reply.question.parentReference && reply.question.parentReference.indexOf(reference) === 0
  )
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  return formatDate(format, date)
}

export const calcCompliances = replies => {
  const NAs = replies.filter(reply => getReplyValue(reply).trim() === CONSTANTS.NA)
  const repliesWithouNAs = replies.filter(el => !NAs.includes(el))
  const nonCompliances = repliesWithouNAs.filter(reply => getReplyValue(reply).trim() === CONSTANTS.NAO_ATENDE)

  if (NAs.length === replies.length) return CONSTANTS.NA

  if (nonCompliances.length === 0) return CONSTANTS.ATENDE

  if (nonCompliances.length === 1) return CONSTANTS.ATENDE_PARCIALMENTE

  if (nonCompliances.length > 1) return CONSTANTS.NAO_ATENDE
}
export const CONSTANTS = {
  NA: 'N/A',
  ATENDE: 'Atende',
  ATENDE_PARCIALMENTE: 'Atende parcialmente',
  NAO_ATENDE: 'Não atende',
  CONFORME: 'Conforme',
  NAO_CONFORME: 'Não Conforme',

  INSPECAO_DE_CAMPO: 'Inspeção de Campo',
  DISPOSICOES_GERAIS: 'Disposições Gerais',
  EPI: 'EPI (Ficha) e Ensaios Elétricos',
  VEICULOS_FERRAMENTAL_DOC: 'Veículo, Ferramental/Doc',
  CIPA: 'CIPA',
  TREINAMENTOS: 'Treinamentos',
  APR: 'APR',
  PREVENCAO_E_COMBATE_A_INCENDIO: 'Prevenção e Combate a Incêndio',
  DOCUMENTACAO_DE_SEGURANCA: 'Documentação de Segurança',
  CEA: 'CEA',
  SAUDE: 'Saúde',
  DESC: 'DESC',
  AMBIENTE_DE_TRABALHO: 'Ambiente de Trabalho'
}
